import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, TransitionGroup as _TransitionGroup, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5819e855"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "fixed top-0 left-0 w-full z-50 h-full flex justify-center items-center bg-opacity-60 bg-gray-900"
}
const _hoisted_2 = { class: "fixed z-50 bottom-6 right-6 pointer-events-none flex flex-col-reverse" }

import {activeDialog, activeToasts, toast} from "@/dialog";
import Loader from "./Loader.vue";
import AlertDialog from "./AlertDialog.vue";
import Toast from "./Toast.vue";
import ConfirmDialog from "./ConfirmDialog.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ModalDisplay',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(activeDialog))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_unref(activeDialog).kind === 'loader')
            ? (_openBlock(), _createBlock(Loader, { key: 0 }))
            : _createCommentVNode("v-if", true),
          (_unref(activeDialog).kind === 'alert')
            ? (_openBlock(), _createBlock(AlertDialog, {
                key: 1,
                title: _unref(activeDialog).title,
                text: _unref(activeDialog).message
              }, null, 8 /* PROPS */, ["title", "text"]))
            : _createCommentVNode("v-if", true),
          (_unref(activeDialog).kind === 'confirmation')
            ? (_openBlock(), _createBlock(ConfirmDialog, {
                key: 2,
                title: _unref(activeDialog).title,
                text: _unref(activeDialog).message,
                "confirmation-id": _unref(activeDialog).id
              }, null, 8 /* PROPS */, ["title", "text", "confirmation-id"]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_TransitionGroup, { name: "toast-list" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(activeToasts), (t) => {
            return (_openBlock(), _createBlock(Toast, {
              type: t.type,
              key: t.id
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(t.text), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["type"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      })
    ])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})